import React from "react";
import initializeReduxStorage from "./store";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { createTheme, ThemeProvider } from "@mui/material";
import { COLORS } from "./shared/constants/layout-constants";
import CssBaseline from "@mui/material/CssBaseline";

const store = initializeReduxStorage();

const Main: React.FC = () => {
	document.body.style.backgroundColor = COLORS.WHITE_BACKGROUND;
	const notistackRef = React.createRef<any>();

	const onClickDismiss = (key: any) => () => {
		notistackRef.current.closeSnackbar(key);
	};

	const theme = createTheme({
		palette: {
			primary: {
				main: COLORS.BRAND_PRIMARY,
			},
			
		},
		typography: {
			  fontFamily: ['NotoSans-Regular'].join(',')
		},
		components:{
			MuiCssBaseline:{
				styleOverrides:`
					@font-face {
					  font-family: 'NotoSans-Regular';
					  font-style: normal;
					  src: url('./assets/fonts/NotoSans-Regular.woff2') format('woff2');
					}
				  `
			}
		}
	});

	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<CssBaseline/>
				<SnackbarProvider
					ref={notistackRef}
					maxSnack={3}
					autoHideDuration={3000}
					anchorOrigin={{ horizontal: "right", vertical: "top" }}
					action={(key) => (
						<span></span>
					)}
				>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</SnackbarProvider>
			</ThemeProvider>
		</Provider>
	);
};

export default Main;
